import React, { useEffect, useState } from "react";
import Page from "../../../components/Page";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Typography,
  Paper,
  Stack,
  TextField,
  Checkbox,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Skeleton,
  Grid,
  Switch,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import axios from "axios";
import SyncLoader from "react-spinners/SyncLoader";
import { Select, InputLabel } from "@mui/material";
import { openInNewTabWithFallback } from "../../../utils/newTabOpener";

const LiveTest = () => {
  const detailObject = JSON.parse(localStorage.getItem("detailObject"));
  const accessArr = detailObject?.access_level?.split(",");
  const role = localStorage.getItem("role");
  const [isFree, setIsFree] = useState("");
  const navigate = useNavigate();

  const getCacheKey = (p, r, f) => {
    const fStr = JSON.stringify(f || {}).replace(/[^a-zA-Z0-9]/g, "");
    return `livetest_cache_${p}_${r}_${fStr}`;
  };

  const [mocktest, setMockTest] = useState(() => {
    try {
      const cached = localStorage.getItem("livetest_cache_1_5_");
      if (cached) {
        const parsed = JSON.parse(cached);
        return parsed.data || [];
      }
    } catch (e) {}
    return [];
  });

  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [deleteConfirm, setDeleteConfirm] = useState(null);
  
  const [loading, setLoading] = useState(() => {
    try {
      const cached = localStorage.getItem("livetest_cache_1_5_");
      return !cached;
    } catch (e) {
      return true;
    }
  });

  const [total, setTotal] = useState(() => {
    try {
      const cached = localStorage.getItem("livetest_cache_1_5_");
      if (cached) {
        const parsed = JSON.parse(cached);
        return parsed.total || 0;
      }
    } catch (e) {}
    return 0;
  });

  const token = localStorage.getItem("token");
  const [exams, setAllExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedMedium, setSelectedMedium] = useState();

  const [apiFilters, setApiFilters] = useState({
    search: "",
    isLive: "true", // Hardcoded to fetch only Live tests
    isFree: "",
    is_active: "",
    medium: "",
    exam_id: "",
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleExamFilterChange = async (event) => {
    setSelectedExam(event.target.value);
    setApiFilters((prev) => ({ ...prev, exam_id: event.target.value }));
    setPage(0);
  };

  const handleStatusFilterChange = (event) => {
    setSelectedStatus(event.target.value);
    setApiFilters((prev) => ({ ...prev, is_active: event.target.value }));
    setPage(0);
  };

  const handleMediumFilterChange = (event) => {
    setSelectedMedium(event.target.value);
    setApiFilters((prev) => ({ ...prev, medium: event.target.value }));
    setPage(0);
  };

  const fetchMockTest = async (pageNum = 1, perPage = 5, filters = {}) => {
    const cacheKey = getCacheKey(pageNum, perPage, filters);
    
    try {
      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        const parsed = JSON.parse(cached);
        setMockTest(parsed.data || []);
        setTotal(parsed.total || 0);
      }
    } catch (e) {}

    const hasCache = localStorage.getItem(cacheKey);
    if (!hasCache) {
      setLoading(true);
    }

    try {
      let url = `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-all-mock-test?page=${pageNum}&limit=${perPage}`;

      if (filters.search) {
        url += `&search=${encodeURIComponent(filters.search)}`;
      }

      if (filters.isLive) {
        url += `&isLive=${filters.isLive}`;
      }

      if (filters.isFree) {
        url += `&isFree=${filters.isFree}`;
      }

      if (filters.exam_id) {
        url += `&exam_id=${filters.exam_id}`;
      }

      if (filters.is_active) {
        url += `&is_active=${filters.is_active}`;
      }

      if (filters.medium) {
        url += `&medium=${filters.medium}`;
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await response.json();

      if (response.ok) {
        const fetchedData = responseData?.data?.data || [];
        const fetchedTotal = responseData?.data?.total || 0;
        
        setMockTest(fetchedData);
        setTotal(fetchedTotal);

        localStorage.setItem(cacheKey, JSON.stringify({
          data: fetchedData,
          total: fetchedTotal
        }));
      } else {
        toast.error("Failed to fetch Live Tests");
      }
    } catch (error) {
      console.error("Error fetching Live Tests:", error);
      toast.error("Error fetching Live Tests");
    }
    setLoading(false);
  };

  const [searchTimeout, setSearchTimeout] = useState(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    const timeout = setTimeout(() => {
      setApiFilters((prev) => ({ ...prev, search: value }));
      setPage(0);
    }, 500);

    setSearchTimeout(timeout);
  };

  const handleClearFilters = () => {
    setApiFilters({ isLive: "true" });
    setSearchValue("");
    setSelectedExam("");
    setSelectedStatus("");
    setSelectedMedium("");
    setPage(0);
  };

  const handleFreeFilterChange = (value) => {
    const newValue = isFree === value ? "" : value;
    setIsFree(newValue);
    setApiFilters((prev) => ({ ...prev, isFree: newValue }));
    setPage(0);
  };

  useEffect(() => {
    fetchMockTest(1, rowsPerPage, apiFilters);
    handleFetchAllExam();
  }, []);

  useEffect(() => {
    fetchMockTest(page + 1, rowsPerPage, apiFilters);
  }, [page, rowsPerPage, apiFilters]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const currentPageRows = mocktest?.map((user) => user.id);
      setSelectedRows(currentPageRows);
      setSelectAll(true);
    } else {
      setSelectedRows([]);
      setSelectAll(false);
    }
  };

  const handleRowSelect = (userId) => {
    if (selectedRows.includes(userId)) {
      setSelectedRows(selectedRows.filter((id) => id !== userId));
    } else {
      setSelectedRows([...selectedRows, userId]);
    }
  };

  useEffect(() => {
    setSelectedRows([]);
    setSelectAll(false);
  }, [page]);

  const handleDeleteSelected = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/delete-bulk-mocktest`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ ids: [...selectedRows] }),
        }
      );

      if (res.ok) {
        toast.success("Deleted successfully");
        fetchMockTest(page + 1, rowsPerPage, apiFilters);
        setSelectedRows([]);
        setSelectAll(false);
      } else {
        toast.error("Failed to delete items");
      }
    } catch (error) {
      console.error("Error deleting items:", error);
      toast.error("Error deleting items");
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleDelete = async () => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/delete-mock-test/${selectedRow.id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.ok) {
        toast.success("Deleted successfully");
        fetchMockTest(page + 1, rowsPerPage, apiFilters);
        handleClose();
      } else {
        toast.error("Failed to delete Live Test");
      }
    } catch (error) {
      console.error("Error deleting Live Test:", error);
      toast.error("Error deleting Live Test");
    }
  };

  const handleCopyMockTest = async (id) => {
    const token = localStorage.getItem("token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/copy-mock-test/${id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fullres = await res.json();

      if (res.ok) {
        toast.success("Live Test copied successfully");
        handleEditManualTest(fullres.data.id);
      } else {
        toast.error("Failed to copy Live Test");
      }
    } catch (error) {
      toast.error("Failed to copy Live Test");
      console.error("Error copying Live Test:", error);
    }
  };

  const [open3, setOpen3] = useState(false);

  const handleClickOpen3 = (index) => {
    setDeleteConfirm(index);
    setOpen3(true);
  };

  const handleClose3 = () => {
    setDeleteConfirm(null);
    setOpen3(false);
  };

  const handleConfirm3 = () => {
    handleDelete();
    handleClose3();
  };

  const changeStatus = async (row) => {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const status = await axios.put(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/change-status/${row?.id}`,
        { is_active: row?.is_active == 0 ? 1 : 0 },
        { headers }
      );

      if (status.status === 200) {
        toast.success("Status changed successfully");
        fetchMockTest(page + 1, rowsPerPage, apiFilters);
      }
    } catch (error) {
      console.error("Error changing status:", error);
      toast.error("Error changing status");
    }
  };

  const handleFetchAllExam = async () => {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_LIVE_URL_NEW}/admin/get-all-exam`,
        { headers }
      );

      if (response.status === 200) {
        setAllExams(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching all exams:", error);
      toast.error("Error fetching all exams");
    }
  };

  const handleEditManualTest = (testId) => {
    const path = `/dashboard/updateManualTest/${testId}`;
    const result = openInNewTabWithFallback(path, "Manual Test Edit");
    if (!result.success) {
      toast.error("Popup blocked. Please allow pop-ups for this site.");
    }
  };

  return (
    <>
      <Page title="Live Tests">
        <Typography className="page-heading">All Live Tests</Typography>
        <Paper
          elevation={0}
          sx={{
            p: 2.5,
            mb: 3,
            borderRadius: "16px",
            bgcolor: "#f8fafc",
            border: "1px solid #e2e8f0",
          }}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <TextField
                label="Search Live Test"
                variant="outlined"
                size="small"
                fullWidth
                value={searchValue}
                onChange={handleSearchChange}
                sx={{ bgcolor: "white" }}
              />
            </Grid>
            
            <Grid item xs={12} md={3} display="flex" gap={2}>
              <FormControlLabel
                control={
                  <Switch
                    checked={isFree === "true"}
                    onChange={(e) => handleFreeFilterChange(e.target.checked ? "true" : "")}
                    color="primary"
                  />
                }
                label="Only Free"
              />
            </Grid>

            <Grid item xs={12} md={5} display="flex" justifyContent="flex-end" gap={2}>
              {selectedRows.length > 0 && (
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={handleDeleteSelected}
                >
                  Delete Selected ({selectedRows.length})
                </Button>
              )}
              <Button
                variant="outlined"
                color="inherit"
                size="small"
                onClick={handleClearFilters}
                sx={{ borderColor: "#cbd5e1" }}
              >
                Clear Filters
              </Button>
            </Grid>

            <Grid item xs={12} md={5}>
              <FormControl variant="outlined" size="small" fullWidth sx={{ bgcolor: "white" }}>
                <InputLabel>Exam Name</InputLabel>
                <Select
                  value={selectedExam}
                  onChange={handleExamFilterChange}
                  label="Filter by Exam"
                >
                  {exams?.map((exam) => (
                    <MenuItem key={exam.id} value={exam.id}>
                      {exam.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={3.5}>
              <FormControl variant="outlined" size="small" fullWidth sx={{ bgcolor: "white" }}>
                <InputLabel>Medium</InputLabel>
                <Select
                  value={selectedMedium || ""}
                  onChange={handleMediumFilterChange}
                  label="Filter by Medium"
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value={1}>English</MenuItem>
                  <MenuItem value={2}>Hindi</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={6} md={3.5}>
              <FormControl variant="outlined" size="small" fullWidth sx={{ bgcolor: "white" }}>
                <InputLabel>Status</InputLabel>
                <Select
                  name="is_active"
                  value={selectedStatus}
                  onChange={handleStatusFilterChange}
                  label="Filter by Status"
                >
                  <MenuItem value={"1"}>Publish</MenuItem>
                  <MenuItem value={"0"}>Draft</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>

        <TableContainer
          component={Paper}
          sx={{ width: "100%", overflowX: "auto" }}
        >
          <Table sx={{ tableLayout: "auto" }}>
            <TableHead style={{ backgroundColor: "#e6e6ff" }}>
              <TableRow>
                {(role === "Admin" || accessArr?.includes("delete")) && (
                  <TableCell padding="checkbox" sx={{ width: 50 }}>
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < mocktest.length
                      }
                    />
                  </TableCell>
                )}
                <TableCell sx={{ width: 150 }}>Name</TableCell>
                <TableCell sx={{ width: 150 }}>Category</TableCell>
                <TableCell sx={{ width: 150 }}>Exam Name</TableCell>
                <TableCell sx={{ width: 100 }}>Language</TableCell>
                <TableCell sx={{ width: 150 }}>Duration (mins)</TableCell>
                <TableCell sx={{ width: 150 }}> Marks</TableCell>
                <TableCell sx={{ width: 150 }}> Question Count</TableCell>
                <TableCell sx={{ width: 150 }}>Negative Marks</TableCell>
                <TableCell sx={{ width: 100 }}>Status</TableCell>
                <TableCell sx={{ width: 100 }}>Add Ques.</TableCell>
                <TableCell sx={{ width: 100 }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (!mocktest || mocktest.length === 0) ? (
                Array.from({ length: rowsPerPage }).map((_, i) => (
                  <TableRow key={i}>
                    {(role === "Admin" || accessArr?.includes("delete")) && (
                      <TableCell padding="checkbox">
                        <Skeleton variant="rectangular" width={20} height={20} />
                      </TableCell>
                    )}
                    <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="60%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="70%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="50%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="60%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="80%" height={24} /></TableCell>
                    <TableCell><Skeleton variant="text" width="40%" height={24} /></TableCell>
                  </TableRow>
                ))
              ) : (
                mocktest?.map((user, index) => (
                  <TableRow key={user.id || index}>
                    {(role === "Admin" || accessArr?.includes("delete")) && (
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedRows.includes(user.id)}
                          onChange={() => handleRowSelect(user.id)}
                        />
                      </TableCell>
                    )}
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.title || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.course}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.exam_name || user?.classes_name}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.language === "en" ? "English" : "Hindi"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.duration || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.eachQuestionMarks || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.count || "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography style={{ cursor: "pointer", whiteSpace: "nowrap" }}>
                        {user?.nagetiveMarking ? user?.nagetiveMarks || "N/A" : "N/A"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => changeStatus(user)}
                        color={user?.is_active === "0" ? "error" : "success"}
                        variant="outlined"
                      >
                        {user?.is_active === "1" ? "Publish" : "Draft"}
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        sx={{
                          minWidth: "100%",
                          maxWidth: "100%",
                          alignSelf: "center",
                          background: "#e6e6ff",
                          color: "black",
                          borderRadius: "20px",
                          "&:hover": { background: " #8080ff" },
                        }}
                        onClick={() => {
                          const path = `/dashboard/mockTest/${user?.title}/${user?.id}/${user?.count}`;
                          const result = openInNewTabWithFallback(path, "Add Questions");
                          if (!result.success) {
                            toast.error("Popup blocked. Please allow pop-ups for this site.");
                          }
                        }}
                      >
                        Add
                      </Button>
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={(e) => handleClick(e, user)}>
                        <MoreVertIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={() => handleEditManualTest(selectedRow?.id)}>
            Edit
          </MenuItem>
          <MenuItem onClick={() => handleClickOpen3(selectedRow?.id)}>
            Delete
          </MenuItem>
          <MenuItem onClick={() => handleCopyMockTest(selectedRow?.id)}>
            Copy
          </MenuItem>
        </Menu>

        <Dialog open={open3} onClose={handleClose3}>
          <DialogTitle>{"Are you sure you want to delete?"}</DialogTitle>
          <DialogActions>
            <Button onClick={handleClose3}>Cancel</Button>
            <Button onClick={handleConfirm3} autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Page>
      <ToastContainer />
    </>
  );
};

export default LiveTest;
